module.exports = __webpack_public_path__ + "img/wire_logic-1.7ade92f2.jpg";